export var TransformStage;

(function (TransformStage) {
  TransformStage["Render"] = "render";
  TransformStage["Serilize"] = "serilize";
  TransformStage["Save"] = "save";
  TransformStage["Clone"] = "clone";
  TransformStage["Init"] = "init";
  TransformStage["Upgrade"] = "upgrade";
})(TransformStage || (TransformStage = {}));